import { smsTemplatePopulatedSchema } from "@redotech/redo-model/sms-template";
import * as z from "zod/v4";

const updateSmsTemplateInputSchema_ = z.object({
  id: z.string(),
  template: smsTemplatePopulatedSchema.omit({ _id: true }),
});
export interface UpdateSmsTemplateInput
  extends z.infer<typeof updateSmsTemplateInputSchema_> {}
export const updateSmsTemplateInputSchema: z.ZodType<UpdateSmsTemplateInput> =
  updateSmsTemplateInputSchema_;

export const updateSmsTemplate = {
  name: "updateSmsTemplate" as const,
  input: updateSmsTemplateInputSchema,
  output: z.null(),
};
